import axios from 'axios'
import store from '@/store'
import Router from '@/router'
import { Loading, Message  } from 'element-ui';


var instance = axios.create()

var loading = null;

// TODO login出现判断
// http request 拦截器
instance.interceptors.request.use(
  config => {
    if (store.state.token) {
      config.headers.Authorization = `${store.state.token}`
    }
    // if (!loading) {
    //   loading = Loading.service({
    //     lock: true,
    //     text: '加载中',
    //     target: window.localStorage.getItem('target') ? window.localStorage.getItem('target') : '.loading-wrapper'
    //   })
    // }
    return config
  },
  err => {
    // loading.close();
    return Promise.reject(err)
  })
  instance.interceptors.response.use(function(res) {
    if (res.status === 204 || res.status === 201 || (res.status === 200 && (Array.isArray(res.data) || res.data.detail == 'ids' || res.data > 0 || res.data.code === 1 || res.data.code === 200 || res.data.results || res.data.updated_at))) {
      // loading.close();
      return res
    } else if (res.data.code === 205 || res.data.code === 10000) {
      // loading.close();
      Message.error('用户登录失败,请重新登录')
      store.dispatch('doLogout')
      Router.push({ name: 'login' })
      return
    } else {
      Message.error(res.data.msg)
      // loading.close();
      return res
    }
  },
  err => {
    return Promise.reject(err)
  })
export default instance